export default "__VITE_ASSET__D39c7Mj8__"